const replacePlaceholders = (str, replacements = {}) => {
  if (!str) return str;
  const parts = str.split(/\{\{([^}]+)}}/g);
  return parts.map(part => {
    return replacements[part] || part;
  });
};

export default replacePlaceholders;
